export default (function (value) {
  return value.toString();
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/toString.js
// module id = UoeN
// module chunks = 0